module.exports = __webpack_public_path__ + "img/btn.27f3a6a7.png";